<template>
  <div class="flex flex-col lg:flex-row border-b border-gray-200 dark:border-dark-5 pb-5 -mx-5">
    <div class="flex flex-1 px-5 items-center justify-center lg:justify-start">
      <div class="w-20 h-20 sm:w-24 sm:h-24 flex-none image-fit relative">
        <div
          class="flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 bg-gray-200 dark:bg-dark-5 rounded-full"
        >
          <UserIcon />
        </div>
      </div>
      <div class="ml-5">
        <div class="text-gray-600 capitalize -mb-1">
          {{ customer.lastName }}
        </div>
        <div class="w-24 sm:w-40 capitalize font-medium text-xl">
          {{ customer.firstName }}
        </div>
        <div :class="['status-tag mt-2', `is-${getStatus(customer.status)}`]">
          {{ $t(`status.${getStatus(customer.status)}`) }}
        </div>
      </div>
    </div>
    <div
      class="flex mt-6 lg:mt-0 flex-1 flex-col justify-center text-gray-600 dark:text-gray-300 px-5 border-l border-r border-gray-200 dark:border-dark-5 border-t lg:border-t-0 pt-5 lg:pt-0"
    >
      <div v-if="customer.phone" class="truncate sm:whitespace-normal flex items-center">
        <PhoneIcon class="w-4 h-4 mr-2" /> {{ customer.phone }}
      </div>
      <div v-if="customer.email" class="truncate sm:whitespace-normal flex items-center mt-1">
        <MailIcon class="w-4 h-4 mr-2" /> {{ customer.email }}
      </div>
      <div v-if="customer.facebookAddress" class="flex items-center mt-1 min-w-0 w-full">
        <FacebookIcon class="w-4 h-4 mr-2 flex-shrink-0" />
        <span class="truncate">{{ customer.facebookAddress }}</span>
      </div>
    </div>
    <div
      class="mt-6 lg:mt-0 flex-1 flex flex-col justify-center text-gray-600  dark:text-gray-300 px-5 border-t lg:border-0 border-gray-200 dark:border-dark-5 pt-5 lg:pt-0"
    >
      <div>
        Хаяг:
        {{ customer | fullAddress }}
        /
        <template v-if="customer.registeredOnAddress === 1">
          <span class="text-green-400">{{ $t('text.registeredHereYes') }}</span>
        </template>
        <template v-else>
          <span class="text-red-400">{{ $t('text.registeredHereNo') }}</span>
        </template>
      </div>
      <div class="mt-1">
        {{ $t('text.timeLivedHere') }}:
        {{ $t('text.timeOnAddress', { number: customer.timeOnAddress }) }}
      </div>
      <div v-if="customer.houseTypeId && customer.houseType" class="mt-1">
        {{ $t('text.houseType') }}: {{ customer.houseType.name }} /
        <template v-if="customer.isHouseOwner === 1">
          <span class="text-green-400">{{ $t('text.houseOwnYes') }}</span>
        </template>
        <template v-else>
          <span class="text-red-400">{{ $t('text.houseOwnNo') }}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import humps from 'humps';

export default {
  props: {
    customer: Object,
  },

  methods: {
    getStatus(status) {
      return status ? humps.camelize(status).toLowerCase() : '';
    },
  },
};
</script>
